import * as R from 'ramda';
import { betaFeaturePrefix, TYPES } from '@trs/utils';

export const INCLUDED = 'included';
const NOT_INCLUDED = 'notIncluded';

const mapReportPayloadToCategoryMappings = payload =>
  R.reduce(
    (acc, item) => {
      const { categoryId, subcategoryId, typeId, isIncluded, isEditable, category } = item;
      const key = `${categoryId}/${subcategoryId}/${typeId}`;

      acc[key] = {
        isIncluded,
        isEditable,
        mappingName: category,
        columnId: isIncluded ? INCLUDED : NOT_INCLUDED,
      };
      return acc;
    },
    {},
    payload
  );

export const checkBetaFeature = (betaFeatureToggles, feature) => {
  return R.equals(betaFeatureToggles[`${betaFeaturePrefix}${feature}`], TYPES.ON);
};

export default mapReportPayloadToCategoryMappings;
